import { FiCopy } from "react-icons/fi";
import styles from "./styles.module.scss";

const AccountDetailRow = ({
	label,
	value,
	branchName,
	showBranchTag,
	onCopy,
}) => {
	return (
		<div className={styles.row}>
			<h4 className={styles.detailLabel}>
				{label}

				{showBranchTag && branchName && (
					<span className={styles.tag}>
						{branchName}
					</span>
				)}
			</h4>

			<div className={`${styles.detailValue} bg-white`}>
				{value}

				<span
					className={styles.pointer}
					onClick={() => onCopy(value)}
				>
					<FiCopy />
				</span>
			</div>
		</div>
	);
};

export default AccountDetailRow;